/* GASSISA
=========================================================================================
* Descripcion: Otras acciones exclusivas para Venta Super portatil.
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revision   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 26/06/2026 | Lic. Jose Luis Aragon Cervantes  | Creacion de panel portatil independiente
* ---------------------------------------------------------------------------------------
*/

import { Button, Divider, Drawer, IconButton, Stack, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import NextPlanIcon from "@mui/icons-material/NextPlan";
import DeleteIcon from "@mui/icons-material/Delete";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import LockIcon from "@mui/icons-material/Lock";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import PriceCheckIcon from "@mui/icons-material/PriceCheck";
import { useVentas } from "../../../context/Ventas/VentasContext";
import { useDoubleClickPrevention } from "../../../hooks/useDoubleClickPrevention";

export default function MnuOtherActionsPortatil({ statusCajaActual, onAbrirAperturaCaja, onAbrirCierreCaja }) {
  const {
    openModal,
    handleCerrarMenuModal,
    handleAbrirModalJalarPreVentaCotizacion,
    handleAbrirModalGenerarApartado,
    handleAbrirRetiroCapital,
    handleClickEliminarPartidaVentas,
    handleClickEliminarVenta,
    handleClickDescuentoVenta,
    handleGuardarVentaComoCotizacion,
    partidaSeleccionada,
    listaRemisionTemporal,
    statusWaiting,
  } = useVentas();
  const { isProcessing, executeWithProtection } = useDoubleClickPrevention();
  const bloqueado = statusWaiting || isProcessing || !statusCajaActual?.abierta;
  const tieneVenta = (listaRemisionTemporal ?? []).length > 0;

  const ejecutar = (accion) => {
    executeWithProtection(accion);
    handleCerrarMenuModal();
  };

  return (
    <Drawer anchor="right" open={Boolean(openModal)} onClose={handleCerrarMenuModal} PaperProps={{ className: "venta-super-portatil__other-actions" }}>
      <div className="venta-super-portatil__other-header"><Typography variant="h6">Otras acciones</Typography><IconButton onClick={handleCerrarMenuModal}><CloseIcon /></IconButton></div>
      <Divider />
      <Stack spacing={0.5} sx={{ p: 1.25 }}>
        <Button startIcon={<NextPlanIcon />} disabled={bloqueado} onClick={() => ejecutar(() => handleAbrirModalJalarPreVentaCotizacion("PREVENTA"))}>Jalar preventa</Button>
        <Button startIcon={<NextPlanIcon />} disabled={bloqueado} onClick={() => ejecutar(() => handleAbrirModalJalarPreVentaCotizacion("COTIZACION"))}>Jalar cotizacion</Button>
        <Button startIcon={<NextPlanIcon />} disabled={bloqueado} onClick={() => ejecutar(handleAbrirModalGenerarApartado)}>Generar apartado</Button>
        <Button color="error" startIcon={<DeleteIcon />} disabled={bloqueado || !partidaSeleccionada?.idpartida} onClick={() => ejecutar(() => handleClickEliminarPartidaVentas(partidaSeleccionada.idpartida))}>Eliminar partida</Button>
        <Button color="error" startIcon={<DeleteIcon />} disabled={bloqueado} onClick={() => ejecutar(handleClickEliminarVenta)}>Eliminar venta</Button>
        <Button startIcon={<NextPlanIcon />} disabled={bloqueado || !tieneVenta} onClick={() => ejecutar(handleGuardarVentaComoCotizacion)}>Terminar como cotizacion</Button>
        <Button startIcon={<PriceCheckIcon />} disabled={bloqueado || !tieneVenta} onClick={() => ejecutar(handleClickDescuentoVenta)}>Descuentos</Button>
        <Button startIcon={<RemoveCircleOutlineIcon />} disabled={bloqueado} onClick={() => ejecutar(handleAbrirRetiroCapital)}>Retiro de efectivo</Button>
        <Button startIcon={<LockOpenIcon />} onClick={() => ejecutar(onAbrirAperturaCaja)}>Apertura de caja</Button>
        <Button startIcon={<LockIcon />} onClick={() => ejecutar(onAbrirCierreCaja)}>Cierre de caja</Button>
      </Stack>
    </Drawer>
  );
}
